import type { CreateViewDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddShopView(shopId: string) {
	return useApiMutation("post", "/shops/{shopId}/views", {
		invalidate: useInvalidateShop(shopId),
		mapVariables: (body: CreateViewDto) => ({
			params: { path: { shopId } },
			body,
		}),
	});
}
